const closeAccordionPanel = (button) => {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    button.setAttribute('aria-expanded', 'false');
    if( panel) {
        panel.hidden = true;
    }
}

const openAccordionPanel = (button) => {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    button.setAttribute('aria-expanded', 'true');
    if( panel) {
        panel.hidden = false;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const textAccordionButtons = document.querySelectorAll('.js-accordion-button');
    textAccordionButtons.forEach(button => {
        button.addEventListener('click', () => {
            const isExpanded = button.getAttribute("aria-expanded");
            if ( isExpanded == 'true' ) {
                closeAccordionPanel(button);
            } else {
                openAccordionPanel(button);
            }
        })
    })
});